import React from "react";
import {withTranslation} from "react-i18next";
import {
    ArrowRightOutlined,LeftOutlined
} from '@ant-design/icons';
import "../../tek.scss";
import {Button} from 'antd';
import {history} from '_helpers/history'
import luxs from "assets/img/LUX_SALUDA.png";
import Headerbutton from "../../../../component/headerButton";
import localOrSessionStore from "_helpers/localOrSessionStore";
import variables from "_constants/variables";

function stepTekTwo(props) {
    const storage = localOrSessionStore({ key: variables.REMEMBER });
    const user = JSON.parse(storage.getItem(variables.USER));
    const {t} =props;

    const saveAndContinue = () => {
        history.push("/admin/assessment")
    }
    return (

        <div className={"containerStartTekTwo wrapper history tek-ko"}>
            <div className={"insideTek boxed"}>
                <Headerbutton  saveAndContinue={saveAndContinue}  />
            </div>
            <div className={"container-history boxed"}>
                <img className={"character character--flip character--lux"} src={luxs} alt={""} />
                <div className={"container-dialogue"}>
                    <div className={"dialogue-content-text"}>
                        <p className={"dialogue-text"}><strong>{t("hi")} {user.name ?? "" }!</strong></p>
                        <p className={"dialogue-text"} dangerouslySetInnerHTML={{__html: t('tek.itin2.presenta')}}></p>
                    </div>
                    <div className={"dialogue-buttons"}>
                        <div className="left margin-right-auto">
                            <Button
                            icon={<LeftOutlined />}
                            type={"link"}
                            onClick={() => props.goTo(1)}
                        >
                            {t("atras")}
                        </Button>
                        </div>
                        <div className="right">
                            <Button icon={<ArrowRightOutlined />}
                            onClick={() => props.goTo(3)}
                            type={"primary"}
                            className="primaryButton"
                        >
                            {t("next")}
                        </Button>
                        </div>
                    </div>
                    <p className={"dialogue-name"}>
                        <strong>LUX</strong>
                    </p>
                </div>
            </div>
        </div>

    )
}

export default withTranslation()(stepTekTwo);
